import { AssistantCreationBody, AssistantCreationResponse, AssistantResponse } from "@boxem/core-api-schema";
import { API } from "../lib/api";
import { TeamMember } from "@/contexts/UserContext";

export function getTeams(ownerUUID: string) {
    return API.get<AssistantResponse>(`/assistants/${ownerUUID}`);
}

export function inviteMember(ownerUUID: string, member: TeamMember) {
  const payload: AssistantCreationBody = {
    name: member.name,
    email: member.email,
    permissions: member.permissions
  }
  return API.post<AssistantCreationResponse>(`/assistants/${ownerUUID}`, payload);
}

export function updateMember(member: TeamMember) {
  const payload = {
    permissions: member.permissions
  }
  return API.patch<AssistantResponse>(`/assistants/${member.relationId}`, payload);
}

export function deleteMember(member: TeamMember) {
  return API.delete(`/assistants/${member.relationId}`);
}

export function confirmMember(token: string) {
  return API.post('/assistants/accept', {token: token});
}